export default "__VITE_ASSET__Dzh3IaDT__"